import { DashboardIcon } from 'icons/DashboardIcon';
import { RentalsIcon } from 'icons/RentalsIcon';
import { CarsIcon } from 'icons/CarsIcon';
import { CustomersIcon } from 'icons/CustomersIcon';
import { ContentIcon } from 'icons/ContentIcon';
import { SettingsIcon } from 'icons/SettingsIcon';
import { DiscountIcon } from 'icons/DiscountIcon';
import { Pages } from 'common/constants';
import { SubscriptionIcon } from 'icons/SubscriptionIcon';
import {
  AdminPanelCars,
  Customers,
  Dashboard,
  Discounts,
  Rentals,
  PageContents,
  Subscriptions,
  Settings,
} from './organisms';
import { AdminPanelRoutesPaths } from './types';

export const adminPanelRoutes = [
  {
    path: AdminPanelRoutesPaths.DASHBOARD,

    element: Dashboard,
    index: true,
  },
  {
    path: AdminPanelRoutesPaths.RENTALS,

    element: Rentals,
  },
  {
    path: AdminPanelRoutesPaths.SUBSCRIPTIONS,
    element: Subscriptions,
  },
  {
    path: AdminPanelRoutesPaths.CARS,
    element: AdminPanelCars,
  },
  {
    element: Customers,
    path: AdminPanelRoutesPaths.CUSTOMERS,
  },
  {
    element: Discounts,

    path: AdminPanelRoutesPaths.DISCOUNTS,
  },
  {
    element: PageContents,

    path: AdminPanelRoutesPaths.CONTENT,
  },
  {
    element: Settings,
    path: AdminPanelRoutesPaths.SETTINGS,
  },
];

export const adminPanelNavigationItems = [
  {
    translationKey: 'ADMIN_NAVIGATION_DASHBOARD',
    link: AdminPanelRoutesPaths.DASHBOARD,
    icon: DashboardIcon,
    pageName: Pages.DASHBOARD,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_RENTALS',
    link: AdminPanelRoutesPaths.RENTALS,
    icon: RentalsIcon,
    pageName: Pages.RENTALS,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_SUBSCRIPTIONS',
    icon: SubscriptionIcon,
    link: AdminPanelRoutesPaths.SUBSCRIPTIONS,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_CARS',
    icon: CarsIcon,
    link: AdminPanelRoutesPaths.CARS,
    pageName: Pages.CARS,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_CUSTOMERS',
    icon: CustomersIcon,
    pageName: Pages.CUSTOMERS,
    link: AdminPanelRoutesPaths.CUSTOMERS,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_DISCOUNTS',
    icon: DiscountIcon,
    pageName: Pages.DISCOUNTS,
    link: AdminPanelRoutesPaths.DISCOUNTS,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_CONTENTS',
    icon: ContentIcon,
    link: AdminPanelRoutesPaths.CONTENT,
    pageName: Pages.CONTENT,
  },
  {
    translationKey: 'ADMIN_NAVIGATION_SETTINGS',
    icon: SettingsIcon,
    link: AdminPanelRoutesPaths.SETTINGS,
  },
];

export const ADMIN_PANEL_ROUTE_NAMES = {
  [`/admin/${AdminPanelRoutesPaths.DASHBOARD}`]: 'ADMIN_NAVIGATION_DASHBOARD',
  [`/admin/${AdminPanelRoutesPaths.RENTALS}`]: 'ADMIN_NAVIGATION_RENTALS',
  [`/admin/${AdminPanelRoutesPaths.SUBSCRIPTIONS}`]:
    'ADMIN_NAVIGATION_SUBSCRIPTIONS',
  [`/admin/${AdminPanelRoutesPaths.CARS}`]: 'ADMIN_NAVIGATION_CARS',
  [`/admin/${AdminPanelRoutesPaths.CUSTOMERS}`]: 'ADMIN_NAVIGATION_CUSTOMERS',
  [`/admin/${AdminPanelRoutesPaths.DISCOUNTS}`]: 'ADMIN_NAVIGATION_DISCOUNTS',
  [`/admin/${AdminPanelRoutesPaths.CONTENT}`]: 'ADMIN_NAVIGATION_CONTENTS',
  [`/admin/${AdminPanelRoutesPaths.SETTINGS}`]: 'ADMIN_NAVIGATION_SETTINGS',
};
